import { useMemo, useState } from "react";
import { useTable } from "react-table";
import primaryComponents from "../../../primaryComponents";
import { DeleteIcon } from "../../../../assets/svgIcons";

export const useIntegratedDeviceList = ({ deviceList }) => {
  const [terminalDetails, setTerminalDetails] = useState(null);
  const [deleteTerminalDetails, setDeleteTerminalDetails] = useState(null);

  const columns = useMemo(
    () => [
      {
        Header: "Serial Number",
        accessor: "terminal_sn",
      },
      {
        Header: "Terminal ID",
        accessor: "terminal_id",
      },
      {
        Header: "Merchant ID",
        accessor: "merchant_id",
      },
      {
        Header: "Store ID",
        accessor: "store",
        Cell: ({ cell: { value } }) => value?.name || "N/A",
      },
      {
        Header: "Enabled On Checkout",
        accessor: "use_on_checkout",
        Cell: ({ cell: { value } }) => (value ? "Yes" : "No"),
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <primaryComponents.Button
              onClick={() => setTerminalDetails(row?.original)}
              classNames={"btn btn--primary smallBtn"}
            >
              Update
            </primaryComponents.Button>
            <span
              className="cursor-pointer"
              onClick={() => setDeleteTerminalDetails(row?.original)}
            >
              <DeleteIcon />
            </span>
          </div>
        ),
      },
    ],
    [],
  );

  const instance = useTable({ columns, data: deviceList });
  return {
    instance,
    terminalDetails,
    deleteTerminalDetails,
    setDeleteTerminalDetails,
    setTerminalDetails,
  };
};
